var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppDialog",
    {
      attrs: {
        title: "海报设置",
        width: "1400px",
        loading: _vm.loading,
        height: "auto",
        top: _vm.top,
      },
      on: { success: _vm.onhandleSave },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c("div", { staticClass: "posterSetting_tips" }, [
        _vm._v("样式支持拖动可支持排列"),
      ]),
      _c(
        "div",
        { staticClass: "posterSetting" },
        [
          _c("MLoading", {
            style: { "background-color": "hsla(0, 0%, 100%, .9)" },
            attrs: { visible: _vm.loading },
          }),
          _c("div", { staticClass: "posterSetting_left" }, [
            _c("div", { staticClass: "posterSetting_bg" }, [
              _c(
                "div",
                {
                  staticClass: "poster_preview",
                  class: { noBg: !_vm.form.bgImg },
                  attrs: { id: "poster_preview" },
                },
                [
                  _vm.form.bgImg
                    ? _c("div", {
                        staticClass: "fix_layer",
                        style: { "background-image": `url(${_vm.form.bgImg})` },
                      })
                    : _vm._e(),
                  _vm.form.liveRoomName.style.opacity === 1
                    ? _c(
                        "VueDragResize",
                        {
                          attrs: {
                            "is-active": _vm.form.liveRoomName.Drag.active,
                            "is-draggable": true,
                            minw: 50,
                            minh: 30,
                            x: _vm.form.liveRoomName.Drag.x,
                            y: _vm.form.liveRoomName.Drag.y,
                            w: _vm.form.liveRoomName.Drag.w,
                            h: _vm.form.liveRoomName.Drag.h,
                            "aspect-ratio": false,
                            "parent-w": 375,
                            "parent-h": 667,
                            "parent-limitation": true,
                            "prevent-active-behavior": false,
                          },
                          on: {
                            clicked: function ($event) {
                              return _vm.onActivated("liveRoomName")
                            },
                            deactivated: _vm.onDeactivated,
                            dragstop: (res) =>
                              _vm.onDragstop("liveRoomName", res),
                            resizestop: (res) =>
                              _vm.onResizstop("liveRoomName", res),
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "poster_layout",
                              style: {
                                ..._vm.form.liveRoomName.style,
                                "font-size":
                                  _vm.form.liveRoomName.style.fontSize + "px",
                              },
                            },
                            [_vm._v("您的直播间名称")]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm.form.liveTime.style.opacity === 1
                    ? _c(
                        "VueDragResize",
                        {
                          attrs: {
                            "is-active": _vm.form.liveTime.Drag.active,
                            "is-draggable": true,
                            minw: 50,
                            minh: 30,
                            x: _vm.form.liveTime.Drag.x,
                            y: _vm.form.liveTime.Drag.y,
                            w: _vm.form.liveTime.Drag.w,
                            h: _vm.form.liveTime.Drag.h,
                            "aspect-ratio": false,
                            "parent-w": 375,
                            "parent-h": 667,
                            "parent-limitation": true,
                            "prevent-active-behavior": false,
                          },
                          on: {
                            clicked: function ($event) {
                              return _vm.onActivated("liveTime")
                            },
                            deactivated: _vm.onDeactivated,
                            dragstop: (res) => _vm.onDragstop("liveTime", res),
                            resizestop: (res) =>
                              _vm.onResizstop("liveTime", res),
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "poster_layout",
                              style: {
                                ..._vm.form.liveTime.style,
                                "font-size":
                                  _vm.form.liveTime.style.fontSize + "px",
                              },
                            },
                            [_vm._v("开播时间： "), _vm._v(" MM-DD 00:00 ")]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm.form.userInfo.style.opacity === 1
                    ? _c(
                        "VueDragResize",
                        {
                          attrs: {
                            "is-active": _vm.form.userInfo.Drag.active,
                            "is-draggable": true,
                            minw: 50,
                            minh: 30,
                            x: _vm.form.userInfo.Drag.x,
                            y: _vm.form.userInfo.Drag.y,
                            w: _vm.form.userInfo.Drag.w,
                            h: _vm.form.userInfo.Drag.h,
                            "aspect-ratio": false,
                            "parent-w": 375,
                            "parent-h": 667,
                            "parent-limitation": true,
                            "prevent-active-behavior": false,
                          },
                          on: {
                            clicked: function ($event) {
                              return _vm.onActivated("userInfo")
                            },
                            deactivated: _vm.onDeactivated,
                            dragstop: (res) => _vm.onDragstop("userInfo", res),
                            resizestop: (res) =>
                              _vm.onResizstop("userInfo", res),
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "poster_layout",
                              style: {
                                ..._vm.form.userInfo.style,
                                "font-size":
                                  _vm.form.userInfo.style.fontSize + "px",
                              },
                            },
                            [
                              _vm._v(
                                "邀请人：" + _vm._s(_vm.form.userInfo.userName)
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm.form.qr.style.opacity === 1
                    ? _c(
                        "VueDragResize",
                        {
                          attrs: {
                            "is-active": _vm.form.qr.Drag.active,
                            "is-draggable": true,
                            minw: 80,
                            minh: 80,
                            x: _vm.form.qr.Drag.x,
                            y: _vm.form.qr.Drag.y,
                            w: _vm.form.qr.Drag.w,
                            h: _vm.form.qr.Drag.h,
                            "aspect-ratio": true,
                            "parent-w": 375,
                            "parent-h": 667,
                            "parent-limitation": true,
                            "prevent-active-behavior": false,
                          },
                          on: {
                            clicked: function ($event) {
                              return _vm.onActivated("qr")
                            },
                            deactivated: _vm.onDeactivated,
                            dragstop: (res) => _vm.onDragstop("qr", res),
                            resizestop: (res) => _vm.onResizstop("qr", res),
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "liveLinkCode",
                              style: { ..._vm.form.qr.style },
                            },
                            [
                              _c("AppQrcode", {
                                attrs: { src: _vm.src, size: 750, margin: 0 },
                              }),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "posterSetting_right" },
            [
              _c(
                "el-form",
                {
                  ref: "ruleForm",
                  staticClass: "demo-ruleForm",
                  attrs: {
                    size: "small",
                    model: _vm.form,
                    rules: _vm.rules,
                    "label-position": "top",
                    "label-width": "80px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "name", label: "样式名称" } },
                    [
                      _c("el-input", {
                        attrs: { maxlength: "10", "show-word-limit": "" },
                        model: {
                          value: _vm.form.name,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "name",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "bgImg", label: "背景图片" } },
                    [
                      _c("AppUploadViewCropper", {
                        key: "MUploadImg",
                        ref: "MUploadImg",
                        attrs: {
                          "upload-text": "上传图片",
                          width: 80,
                          height: 104,
                          accept: ".jpg,.jpeg,.png",
                          "max-length": 1,
                          "cropper-option": {
                            // 裁剪设置
                            fixed: true, // 是否开启截图框宽高固定比例
                            infoTrue: false, // 为展示真实输出图片宽高 false 展示看到的截图框宽高	false	true | false
                            centerBox: false, // 截图框是否被限制在图片里面	false	true | false
                            canMoveBox: true, // 截图框能否拖动	true	true | false
                            fixedNumber: [375, 667], // 截图框的宽高比例 [宽度, 高度]
                            original: false,
                            autoCropWidth: 375,
                          },
                        },
                        on: {
                          onClick: _vm.onImgClick,
                          change: _vm.onSelectImg,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "liveRoomName", label: "直播间名称" } },
                    [
                      _c(
                        "posterSettingPanel",
                        {
                          model: {
                            value: _vm.form.liveRoomName.style,
                            callback: function ($$v) {
                              _vm.$set(_vm.form.liveRoomName, "style", $$v)
                            },
                            expression: "form.liveRoomName.style",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.form.liveRoomName.style.opacity,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form.liveRoomName.style,
                                    "opacity",
                                    $$v
                                  )
                                },
                                expression: "form.liveRoomName.style.opacity",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("展示"),
                              ]),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("不展示"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "liveTime", label: "直播时间" } },
                    [
                      _c(
                        "posterSettingPanel",
                        {
                          model: {
                            value: _vm.form.liveTime.style,
                            callback: function ($$v) {
                              _vm.$set(_vm.form.liveTime, "style", $$v)
                            },
                            expression: "form.liveTime.style",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.form.liveTime.style.opacity,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form.liveTime.style,
                                    "opacity",
                                    $$v
                                  )
                                },
                                expression: "form.liveTime.style.opacity",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("展示"),
                              ]),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("不展示"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "userInfo", label: "邀请人" } },
                    [
                      _c(
                        "posterSettingPanel",
                        {
                          attrs: {
                            setting: { showName: true, showFontWeight: false },
                          },
                          model: {
                            value: _vm.form.userInfo.style,
                            callback: function ($$v) {
                              _vm.$set(_vm.form.userInfo, "style", $$v)
                            },
                            expression: "form.userInfo.style",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              staticStyle: { width: "462px" },
                              model: {
                                value: _vm.form.userInfo.style.opacity,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form.userInfo.style,
                                    "opacity",
                                    $$v
                                  )
                                },
                                expression: "form.userInfo.style.opacity",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("展示"),
                              ]),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("不展示"),
                              ]),
                            ],
                            1
                          ),
                          _c("el-input", {
                            staticStyle: { width: "462px" },
                            attrs: { slot: "userName" },
                            slot: "userName",
                            model: {
                              value: _vm.form.userInfo.userName,
                              callback: function ($$v) {
                                _vm.$set(_vm.form.userInfo, "userName", $$v)
                              },
                              expression: "form.userInfo.userName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "qr", label: "二维码样式" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.form.qr.style.opacity,
                            callback: function ($$v) {
                              _vm.$set(_vm.form.qr.style, "opacity", $$v)
                            },
                            expression: "form.qr.style.opacity",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("展示"),
                          ]),
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("不展示"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialogFooter",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", loading: _vm.subLoading },
              on: { click: _vm.onhandleBack },
            },
            [_vm._v("返回")]
          ),
          _c(
            "el-button",
            {
              attrs: {
                size: "small",
                type: "primary",
                loading: _vm.subLoading,
              },
              on: { click: _vm.onSave },
            },
            [_vm._v("保存")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }